import axiosInstance from "./AxiosInstance";

const API_URL = "/reports";

/* The report generator's three calls. The page draws its own loading states,
   so each is `silent` -- the app's global veil would cover the very panel
   saying it is working. Filtering, grouping and every total happen on the
   API; these only carry the definition there and the report back. */

// { role, sources: [{ id, label, description }] }
export const getReportSources = async () => {
  const response = await axiosInstance.get(`${API_URL}/sources`, { silent: true });
  return response.data?.data || { role: null, sources: [] };
};

// { id, label, description, rowNoun, fields, operators, metrics, defaultColumns, defaultSort, defaultChart, limits }
// Not served from the API's per-user GET cache: the fields and conditions
// offered must be the ones the report will accept today.
export const getReportSource = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/sources/${encodeURIComponent(id)}`, {
    params: { cache: 0 },
    silent: true,
  });
  return response.data?.data || null;
};

// One page of a choice field's options, searched on the API within the
// caller's scope. `fresh` skips the API's per-user GET cache (the dropdown's
// refresh). { options: [{ value, label }], pagination: { page, limit, total, totalPages, hasNext } }
export const getReportFieldOptions = async (sourceId, fieldKey, { search = "", page = 1, limit = 20, fresh = false } = {}) => {
  const params = { search, page, limit };
  if (fresh) params.cache = 0;
  const response = await axiosInstance.get(
    `${API_URL}/sources/${encodeURIComponent(sourceId)}/options/${encodeURIComponent(fieldKey)}`,
    { params, silent: true },
  );
  return response.data?.data || { options: [], pagination: null };
};

// { source, conditions, grouping, summary, rowCount, chart, columns, rows, pagination, truncated, generatedAt }
export const runReport = async (definition) => {
  const response = await axiosInstance.post(`${API_URL}/run`, definition, { silent: true, timeout: 90000 });
  return response.data?.data || null;
};

/** The API's message for a failed call, or a plain fallback. */
export const reportErrorMessage = (error, fallback = "The report could not be generated.") =>
  error?.response?.data?.message?.message || error?.response?.data?.message || fallback;
